export class Formatter {
    public formatPrice(value: number): string | null {
        if (!value) { return null }
        if (value < 1) {
            const str = value.toString();
            const match = str.match(/0\.0*/);
            const leadingZeros = match ? match[0].length - 2 : 0;
            return `$${value.toFixed(leadingZeros + 4)}`;
        }
        return `$${value.toFixed(2)}`;
    }

    public formatPercentage(value: number): string | null {
        if (!value) { return null }
        if (value < 0.01) {
            const str = value.toString();
            const match = str.match(/0\.0*/);
            const leadingZeros = match ? match[0].length - 2 : 0;
            return `${value.toFixed(leadingZeros + 2)}%`;
        }
        return `${value.toFixed(2)}%`;
    }

    public formatLargeNumber(value: number): string | null {
        if (!value) { return null }
        if (value >= 1e12) {
            return `$${(value / 1e12).toFixed(2)}T`;
        }
        if (value >= 1e9) {
            return `$${(value / 1e9).toFixed(2)}B`;
        }
        if (value >= 1e6) {
            return `$${(value / 1e6).toFixed(2)}M`;
        }
        if (value >= 1e3) {
            return `$${(value / 1e3).toFixed(2)}K`;
        }
        return `$${value.toFixed(2)}`;
    }
}

export const formatter = new Formatter();